import { h, createRef } from 'preact';
import register from '@wcd/preact-custom-element';
import { useEffect, useState } from 'preact/hooks';
import { PreviewFiles } from '../../../types/web-components';
import './tabs';

export const component: PreviewFiles = ({ children }) => {
  const ref: any = createRef();

  const [fullscreen, setFullscreen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const container = ref.current.querySelector('.rdp-preview__fullscreen-container');
    const overlay = ref.current.querySelector('.rdp-preview__fullscreen-overlay');
    const arrowLeft = ref.current.querySelector('.rdp-preview__arrow-left');
    const arrowRight = ref.current.querySelector('.rdp-preview__arrow-right');
    const closeFullscreen = ref.current.querySelector('.rdp-preview__fullscreen-close');
    const attachments = ref.current.querySelectorAll('.rdp-preview__item--file');
    const body = document.querySelector('body');

    const resetPreviousSlide = () => {
      const previousItem = ref.current?.querySelector('.active-item');
      previousItem?.classList.remove('active-item');
      previousItem?.removeAttribute('style');
      return Number(previousItem?.getAttribute('data-slide'));
    };

    const enableArrows = () => {
      arrowLeft?.removeAttribute('disabled');
      arrowRight?.removeAttribute('disabled');
    };

    const previousSlide = (e) => {
      e.stopPropagation();
      const previousSlideNumber = resetPreviousSlide();
      const newSlideNumber = previousSlideNumber - 1;
      setCurrentSlide(newSlideNumber);
    };

    const nextSlide = (e) => {
      e.stopPropagation();
      const previousSlideNumber = resetPreviousSlide();
      const newSlideNumber = previousSlideNumber + 1;
      setCurrentSlide(newSlideNumber);
    };

    const showFullscreen = (e) => {
      e.stopPropagation();
      if(!fullscreen){
        const target = e.currentTarget || e.target;
      
        const trackingEvent = target.getAttribute('data-tracking-event') || '';
        const clickEvent = trackingEvent.split(' ').find(t => t.startsWith('click'));
        const trackingId = target.getAttribute('data-tracking-id');
        const name = target.getAttribute('data-name')?.toLowerCase();
        const entityId = target.getAttribute('data-entity-id') || null;
        const entityType = target.getAttribute('data-entity-type') || undefined;
        const productArea = target.getAttribute('data-product-area')?.toLowerCase();
      
        if (clickEvent && typeof window.dispatchEvent === 'function') {
          const customEvent = new CustomEvent('customTrackingEvent', {
            bubbles: true,
            cancelable: true,
            detail: {
              trackingId,
              trackingEvent,
              clickEvent,
              name,
              entityId,
              entityType,
              productArea,
              referrer:document.referrer || window.location.href
            },
          });
          target.dispatchEvent(customEvent);
        }
      }
        const previousItem = ref.current?.querySelector('.active-item');
        previousItem?.classList.remove('active-item');
        const activeItem = e.target;
        activeItem?.parentNode.classList.add('active-item');
        const slide = Number(activeItem?.parentNode.getAttribute('data-slide'));
        setFullscreen(true);
        setCurrentSlide(slide);
    };

    const hideFullscreen = (e) => {
      e.stopPropagation();
      const previousItem = ref.current?.querySelector('.active-item');
      previousItem?.classList.remove('active-item');
      previousItem?.removeAttribute('style');
      enableArrows();
      setFullscreen(false);
    };

    if (fullscreen) {
      enableArrows();
      if (currentSlide === 0) {
        arrowLeft?.setAttribute('disabled', 'true');
      }
      if (currentSlide + 1 === attachments.length) {
        arrowRight?.setAttribute('disabled', 'true');
        closeFullscreen.focus();
      }
      body?.classList.add('tes-modal--opened-container');
      container.classList.add('rdp-preview__fullscreen');
      overlay.classList.add('visible');
      arrowLeft?.classList.add('visible');
      arrowRight?.classList.add('visible');
      const newItem = ref.current?.querySelector(`figure[data-slide="${currentSlide}"]`);
      newItem?.classList.add('active-item');
      closeFullscreen.addEventListener('click', hideFullscreen);
      container.addEventListener('click', hideFullscreen);
    } else {
      body?.classList.remove('tes-modal--opened-container');
      container?.classList.remove('rdp-preview__fullscreen');
      overlay.classList.remove('visible');
      arrowLeft?.classList.remove('visible');
      arrowRight?.classList.remove('visible');
    }

    for (const attachment of attachments) {
      attachment.addEventListener('click', showFullscreen);
    }

    arrowLeft?.addEventListener('click', previousSlide);
    arrowRight?.addEventListener('click', nextSlide);

    return () => {
      arrowLeft?.removeEventListener('click', previousSlide);
      arrowRight?.removeEventListener('click', nextSlide);

      for (const attachment of attachments) {
        attachment.removeEventListener('click', showFullscreen);
      }

      document.removeEventListener('click', hideFullscreen);
    };
  });

  return <div ref={ref}>{children}</div>;
};
register(component, 'tes-preview-files', [], { shadow: false });